import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';


const Footer = () => {
  return (
    <footer className="footer">
      <div className='social-media-icons'>
        <Link to="https://www.linkedin.com/in/sara-lynn-4a3551301/">
          <i className="fa-brands fa-linkedin" />
        </Link>
        <Link to="https://www.instagram.com/brainacs.de/">
          <i className="fa-brands fa-instagram" />
        </Link>
      </div>
      <div className="footer-links">
        <Link to="/impressum">Impressum</Link>
        <Link to="/datenschutz" href="/datenschutz">Datenschutz</Link>
        <Link to="/kontaktiere-Uns">Kontakt</Link>
      </div>
      <div className='footer-text-box'>
        <p className="footer-text">© {new Date().getFullYear()} Brainacs</p>
      </div>
    </footer>
  );
};

export default Footer;
